import { DefaultApiGetDataImportRunsRequest } from "@coeff/api-admin-ext";
import React from "react";

import { FlexRow, Tag } from "../../../components";
import { ExportCSVButton } from "../../WorkspaceAdmin/ExportCSVButton";
import { TabName } from "../../WorkspaceAdmin/WorkspaceAdmin";
import { TableFilters } from "../useTableFilters";

import { DebouncedSearchInput } from "./DebouncedSearchInput";
import {
  DataSourceFilterPopover,
  RunStatusFilterPopover,
  TriggerFilterPopover,
  UserFilterPopover,
} from "./FilterPopovers";

type Props = {
  domain: string;
  search: string;
  onSearchChange: (search: string) => void;
  filters: TableFilters<keyof DefaultApiGetDataImportRunsRequest>;
  setFilters: (filters: TableFilters<keyof DefaultApiGetDataImportRunsRequest>) => void;
};

export const DataImportRunsFilterToolbar: React.FC<Props> = ({
  domain,
  onSearchChange,
  search,
  filters,
  setFilters,
}) => {
  const dataImportId = filters.data_import_id?.[0];

  return (
    <FlexRow style={{ justifyContent: "space-between" }}>
      <FlexRow style={{ flex: 1 }}>
        <DebouncedSearchInput initialSearch={search} onChange={onSearchChange} />

        {dataImportId ? (
          <Tag
            closable
            onClose={() =>
              setFilters({
                ...filters,
                data_import_id: undefined,
              })
            }
          >
            <b>Import:</b> {dataImportId}
          </Tag>
        ) : null}
      </FlexRow>

      <FlexRow>
        <DataSourceFilterPopover
          table="data_import_runs"
          domain={domain}
          values={filters.data_source_type}
          onChange={values =>
            setFilters({
              ...filters,
              data_source_type: values,
            })
          }
        />

        <UserFilterPopover
          table="data_import_runs"
          domain={domain}
          values={filters.user_id}
          onChange={values =>
            setFilters({
              ...filters,
              user_id: values,
            })
          }
        />

        <RunStatusFilterPopover
          values={filters.status}
          onChange={values =>
            setFilters({
              ...filters,
              status: values,
            })
          }
        />

        <TriggerFilterPopover
          values={filters.trigger}
          onChange={values =>
            setFilters({
              ...filters,
              trigger: values,
            })
          }
        />

        <ExportCSVButton tab={TabName.runs} />
      </FlexRow>
    </FlexRow>
  );
};
